export default {"src":"/_next/static/media/aws.8dff8f22.svg","height":153,"width":256,"blurWidth":0,"blurHeight":0};